import React from 'react';
import { formatProjectDateOnly, getProjectToday } from 'src/utils/date';
import { useProjectSettingCtx } from 'src/features/projects/contexts/ProjectSettingContext';

export type MilestoneStatus = 'PLANNED' | 'DUE' | 'PARTIAL' | 'PAID';

function cmpDate(a: string, b: string) {
    // YYYY-MM-DD 문자열 비교는 lexicographic으로 OK
    return a.localeCompare(b);
}

export default function MilestoneStatusBadge({
    dueDate,
    plan,
    actual,
}: {
    dueDate?: string | null;
    plan: number;
    actual: number;
}) {
    const { setting } = useProjectSettingCtx();
    const zone = setting?.timeZone ?? 'Asia/Seoul';

    const planN = Number.isFinite(plan) ? plan : 0;
    const actualN = Number.isFinite(actual) ? actual : 0;

    const due = dueDate ? formatProjectDateOnly(dueDate, zone, '') : null;
    const today = getProjectToday(zone);

    let status: MilestoneStatus = 'PLANNED';
    if (planN > 0 && actualN >= planN) status = 'PAID';
    else if (actualN > 0) status = 'PARTIAL';
    else if (due && cmpDate(due, today) <= 0) status = 'DUE';
    else status = 'PLANNED';

    const badgeClass =
        status === 'PAID'
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
            : status === 'PARTIAL'
            ? 'bg-amber-50 text-amber-700 border-amber-200'
            : status === 'DUE'
            ? 'bg-rose-50 text-rose-700 border-rose-200'
            : 'bg-gray-50 text-gray-700 border-gray-200';

    const label = status === 'PAID' ? 'PAID' : status === 'PARTIAL' ? 'PARTIAL' : status === 'DUE' ? 'DUE' : 'PLANNED';

    return (
        <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] ${badgeClass}`}>
            {label}
        </span>
    );
}
